import { IFramework, IWebServiceManager, HttpMethod } from '@truckdown/framework';
import { AnalyticModel, FactModel, DimensionModel } from './AnalyticModel';
import { IAnalyticProcessor } from './IAnalyticProcessor';

class AnalyticProcessor implements IAnalyticProcessor {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;

    private getFacts(facts: FactModel[]): any[] {
        if (!facts || facts.length == 0) {
            return [];
        }

        let res = [];
        for (let i = 0; i < facts.length; i++) {
            res.push({
                n: facts[i].name,
                v: facts[i].value
            });
        }
        return res;
    }

    private getDimensions(dimensions: DimensionModel[]): any[] {
        if (!dimensions || dimensions.length == 0) {
            return [];
        }

        let res = [];
        for (let i = 0; i < dimensions.length; i++) {
            res.push({
                n: dimensions[i].name,
                v: dimensions[i].value,
                c: this.getDimensions(dimensions[i].children)
            });
        }
        return res;
    }

    private getModel(model: AnalyticModel): any {
        if (!model || model == null) {
            return null;
        }

        return {
            _id: model.id,
            pd: model.processedDate,
            r: model.reversed,
            k: model.key,
            c: model.cube,
            h: model.host,
            t: model.time,
            f: this.getFacts(model.facts),
            d: this.getDimensions(model.dimensions),
            dd: this.getDimensions(model.drilledDimensions)
        };
    }

    process(model: AnalyticModel): Promise<undefined> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: '/analytics/v3/add',
            method: HttpMethod.PUT
        }, this.getModel(model));

        return new Promise<undefined>((resolve, reject) => {
            this.manager
                .send(req)
                .then((res) => {
                    if (res.ok) {
                        resolve(undefined);
                    } else {
                        reject(res.statusText);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    reject(err);
                })
        });
    }
}


export default (framework: IFramework) => {
    framework.registerTransient<IAnalyticProcessor>('IAnalyticProcessor', (frm) => {
        return new AnalyticProcessor(frm);
    });
}
